import React from 'react';
import Link from 'next/link';

export default function SiteFooter() {
  return (
    <footer style={{ padding: '14px 0 34px' }}>
      <div style={{
        width: 'min(1180px, calc(100% - 32px))',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '18px',
        paddingTop: '12px',
        borderTop: '1px solid rgba(18,32,51,.08)',
        flexWrap: 'wrap',
      }}>
        <div style={{ fontWeight: 900, fontSize: '1.08rem' }}>Printer Setup Online</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '18px', flexWrap: 'wrap' }}>
          <Link href="/contact" style={{ color: '#496178', fontWeight: 700, textDecoration: 'none' }}>Contact Us</Link>
          <Link href="/privacy" style={{ color: '#496178', fontWeight: 700, textDecoration: 'none' }}>Privacy Policy</Link>
          <Link href="/terms" style={{ color: '#496178', fontWeight: 700, textDecoration: 'none' }}>Terms of Service</Link>
          <Link href="/disclaimer" style={{ color: '#496178', fontWeight: 700, textDecoration: 'none' }}>Disclaimer</Link>
        </div>
      </div>
      <div style={{ textAlign: 'center', marginTop: '14px', fontSize: '14px', color: '#6b7c8f' }}>
        © 2025 PrinterSetupOnline.com — All rights reserved.
      </div>
      <div style={{ textAlign: 'center', marginTop: '6px', fontSize: '13px', color: '#8a99ab' }}>
        This website provides general printer setup guidance for home and office devices.
      </div>
    </footer>
  );
}
